module.exports = __webpack_public_path__ + "assets/img/progress_cn.c2c76687.png";